// Shared source of truth for the default index.html content.
export const DEFAULT_MAIN_GROUP_INDEX_CONTENT = `---
title: "ShadowClaw Pages"
created: "1970-01-01T00:00:00Z"
updated: "1970-01-01T00:00:00Z"
slug: "shadow-claw-pages"
---

<article>
  <h2>Welcome to ShadowClaw Pages</h2>
  <p>This is the default static page for your workspace.</p>
  <h2 id="getting-started-with-shadowclaw">Getting started with ShadowClaw</h2>
  <h3 id="what-is-memorymd">What is MEMORY.md?</h3>
  <ul>
    <li>
      "<a href="/files/main/MEMORY.md">MEMORY.md</a>" is a per conversation, per
      invocation, auto-loaded, persistent agent memory file.
    </li>
    <li>
      It is designed to be a helpful scratchpad for agents to store important
      information, notes, and context about the conversation.
    </li>
  </ul>
  <h3 id="how-to-use-files">How to use Files</h3>
  <ul>
    <li>Open "<a href="/files/main">Files</a>" to browse your workspace.</li>
    <li>
      Edit and preview files with the file viewer:
      <ul>
        <li><a href="/files/main/index.html">index.html</a></li>
      </ul>
    </li>
  </ul>
  <h3 id="how-to-use-pages">How to use Pages</h3>
  <ul>
    <li>Use Set as Page on any markdown or HTML file to add it to Pages.</li>
    <li>Remove a page anytime from the "<a href="/pages">Pages</a>" view.</li>
  </ul>
  <h3 id="how-to-use-chat">How to use Chat</h3>
  <ul>
    <li>
      Open "<a href="/settings">Settings</a>" to configure your agent's system
      prompt, tools, and more.
    </li>
    <li>
      Open "<a href="/chat/main">Chat</a>" to start a conversation with your
      agent.
    </li>
  </ul>
  <h2 id="further-information">Further information</h2>
  <ul>
    <li>
      <a href="https://github.com/xt-ml/shadow-claw#-shadowclaw"
        >ShadowClaw Project</a
      >
    </li>
    <li><a href="https://deepwiki.com/xt-ml/shadow-claw">Deep Wiki</a></li>
  </ul>
</article>`;
